import React, { useCallback, useMemo } from 'react'
import GenerateWithAIButton from 'app/components/buttons/GenerateWithAIButton'
import { useIntl } from 'react-intl'

export default (props) => {
  const { formatMessage } = useIntl()
  const { editorState, onGenerateContentWithAIClick } = props
  const isEnabled = useMemo(
    () => Boolean(editorState.getCurrentContent().getPlainText()),
    [editorState],
  )
  const onClick = useCallback(() => {
    if (onGenerateContentWithAIClick)
      onGenerateContentWithAIClick(
        editorState.getCurrentContent().getPlainText(),
      )
  }, [editorState, onGenerateContentWithAIClick])
  if (!isEnabled) return null
  return (
    <GenerateWithAIButton
      text={formatMessage({
        id: 'tour.AbbyCreateMessage.firstStep.body',
      })}
      onClick={onClick}
      disabled={!isEnabled}
    />
  )
}
